export default __webpack_public_path__ + "static/media/microlend-boss.fc3deee8.jpg";